module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/level-2_start-4d063116996736a0857946bae11d2af6.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/level-2_start.png
// module id = 449
// module chunks = 2